import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import type { Song } from "@libs/wire";
import { timestamps } from "../utils/fields";

// Per-entity-ID durable cache for song wire shape. Single-column PK on
// songId — single-user app, no multi-account scoping needed (logout wipes
// the SQLite db). The data column is JSON-encoded `Song` from the catalog
// router.
//
// Reads / writes are coordinated by `withEntityCache` (utils/durableCache),
// which validates each row against `songSchema` before returning or writing.
export const cachedSongs = sqliteTable("cached_songs", {
  ...timestamps,
  songId: text("song_id").primaryKey(),
  data: text("data", { mode: "json" }).notNull().$type<Song>(),
  fetchedAt: integer("fetched_at", { mode: "timestamp_ms" }).notNull(),
});

export type CachedSongRow = typeof cachedSongs.$inferSelect;
